import { unique } from '@cli-utils/shared.js'

/**
 * Unknown ids in `betterstart.config` are dropped rather than throwing so a
 * config naming a removed installable stays loadable.
 */
export function normalizeInstalledIds<TId extends string>(
  installedIds: string[] | undefined,
  isId: (value: string) => value is TId
): TId[] {
  return unique((installedIds ?? []).filter(isId)).sort()
}
